import React, { useState } from "react";
import classnames from "classnames";

import ArrowRightIcon from "@vahak/core/dist/icons/arrow_right.svg";
import HomepageV2Animate from "../animate/HomepageV2Animate";
import HomepageV2SectionCard from "../section-card/HomepageV2SectionCard";
import WebV2SectionHeader from "../web-v2-section-header/WebV2SectionHeader";
import Styles from "./WebV2FaqSection.module.scss";

export type WebV2FaqItem = { question: string; answer: string };

interface WebV2FaqSectionProps {
    eyebrow?: string;
    title: string;
    items: WebV2FaqItem[];
    titleClassName?: string;
    containerClassName?: string;
    align?: "center" | "left";
}

const WebV2FaqSection = ({
    eyebrow,
    title,
    items,
    titleClassName,
    containerClassName,
    align = "center"
}: WebV2FaqSectionProps) => {
    const [openIndex, setOpenIndex] = useState(-1);

    return (
        <HomepageV2SectionCard variant="white">
            <div className={classnames(Styles.container, containerClassName)}>
                <HomepageV2Animate variant="fade-up">
                    <WebV2SectionHeader
                        eyebrow={eyebrow}
                        title={title}
                        align={align}
                        className={Styles.sectionHeader}
                        titleClassName={classnames(Styles.sectionTitle, titleClassName)}
                    />
                </HomepageV2Animate>

                <div className={Styles.list}>
                    {items.map((item, index) => {
                        const isOpen = openIndex === index;

                        return (
                            <HomepageV2Animate key={item.question} variant="fade-up" delay={index * 70}>
                                <div className={classnames(Styles.item, isOpen && Styles.itemOpen)}>
                                    <button
                                        type="button"
                                        className={Styles.questionBtn}
                                        aria-expanded={isOpen}
                                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                                    >
                                        <span>{item.question}</span>
                                        <ArrowRightIcon
                                            className={classnames(Styles.chevron, isOpen && Styles.chevronOpen)}
                                            aria-hidden
                                        />
                                    </button>
                                    <div
                                        className={classnames(Styles.answerWrap, isOpen && Styles.answerWrapOpen)}
                                        aria-hidden={!isOpen}
                                    >
                                        <div className={Styles.answerInner}>
                                            <p className={Styles.answer}>{item.answer}</p>
                                        </div>
                                    </div>
                                </div>
                            </HomepageV2Animate>
                        );
                    })}
                </div>
            </div>
        </HomepageV2SectionCard>
    );
};

export default WebV2FaqSection;
